import React, {useEffect, useState} from 'react';
import './DeviceSettings.css';
import {useTranslation} from "react-i18next";
import {useParams} from 'react-router-dom';
import {Container} from "react-bootstrap";
import {Accordion} from "react-bootstrap";
import BackButton from "../../components/BackButton/BackButton";
import GetDeviceCoresQuery from '../../queries/DeviceHeartbeat/GetDeviceCores';
import InteractiveSettings from "../../components/InteractiveSettings/InteractiveSettings";
import {useDispatch} from "react-redux";
import {disableLoading, enableLoading} from "../../features/loading/loadingSlice";

export default function DeviceSettings() {
    const {t} = useTranslation();
    const params = useParams();
    const [cores, setCores] = useState([]);


    const dispatch = useDispatch();

    const deviceId = params.deviceID;

    useEffect(() => {
        fetchCores();
    }, []);

    const fetchCores = () => {
        dispatch(enableLoading());
        GetDeviceCoresQuery(deviceId).then((response) => {
            if (response.status === 200) {
                let data = response.data.data;
                setCores(data);
            }

            dispatch(disableLoading());
        }).catch(() => {
            dispatch(disableLoading());
        })
    }

    return (<>
        <BackButton/>
        <>

            <Container fluid>
                <Accordion className='custom-accordion' defaultActiveKey="0">
                    {cores.map((core, index) => (<Accordion.Item key={core} eventKey={index}>
                        <Accordion.Header>{core}</Accordion.Header>
                        <Accordion.Body fluid>
                            <InteractiveSettings deviceId={deviceId} core={core}/>
                        </Accordion.Body>
                    </Accordion.Item>))}
                </Accordion>
            </Container>
        </>
    </>);
}